import { useRouter } from 'next/router';
import { twJoin } from 'tailwind-merge';

import ToggleBadge from 'molecules/Badge/ToggleBadge';
import Button from 'molecules/Button';
import DropDown from 'molecules/Dropdown';

import usePressListingStore, { clearPressFilters, updatePressFilters } from 'layout/Listing/variants/press/store';

import externalPressCategories from 'data/externalPressTags.json';
import pressCategories from 'data/pressTags.json';

import type { FC } from 'react';

interface PressFiltersProps {}

const PressFilters: FC<PressFiltersProps> = () => {
  const filter = usePressListingStore(state => state.filters);
  const allTags = Array.from(new Set([...pressCategories, ...externalPressCategories]));
  const router = useRouter();

  return (
    <>
      {allTags && (
        <div className="col-span-full hidden flex-wrap items-center gap-4 lg:flex">
          <ToggleBadge
            label="All"
            defaultPressed
            pressed={filter === 'All'}
            onPressedChange={e => e && updatePressFilters(router, 'All')}
          />
          {allTags.map(category => (
            <ToggleBadge
              key={category}
              label={category}
              pressed={filter === category}
              onPressedChange={e => e && updatePressFilters(router, category)}
            />
          ))}
          <Button
            className={twJoin(filter === 'All' && 'hidden')}
            hierarchy="linkGray"
            startIcon="x-circle"
            label="Clear Filters"
            onClick={clearPressFilters}
          />
        </div>
      )}
      <div className="flex items-center lg:hidden">
        <Button
          className={twJoin(filter === 'All' && 'hidden')}
          hierarchy="linkGray"
          startIcon="x-circle"
          label="Clear Filters"
          onClick={clearPressFilters}
        />
      </div>
      <div className="lg:hidden">
        <DropDown
          placeholder="Filter by category"
          options={allTags}
          value={[filter]}
          onChange={e => updatePressFilters(router, e as string)}
        />
      </div>
    </>
  );
};

export default PressFilters;
